/**
 * WEB-2997 — раскладка графа своей воронки (место узла по id экрана и
 * выбранное направление): `GET`/`PATCH /projects/:projectId/quizzes|paywalls/:id/graph-layout`.
 *
 * Отдельно от черновика: запись не двигает отметку версии и не мешает
 * сохранению черновика у коллеги. PATCH сливает места по экранам — узлы,
 * которых нет в теле, остаются как были; `replace: true` — полная замена
 * («Авторасставить»).
 */
import { api } from '@/api/client';
import type { components } from './generated/schema';

export type GraphLayoutDto = components['schemas']['GraphLayoutResponseDto'];
export type GraphLayoutPatchBody = components['schemas']['GraphLayoutPatchDto'];
export type GraphPieceKind = 'quiz' | 'paywall';

const path = (kind: GraphPieceKind, projectId: string, id: string) =>
  `/projects/${projectId}/${kind === 'quiz' ? 'quizzes' : 'paywalls'}/${id}/graph-layout`;

export const graphLayoutApi = {
  get: (kind: GraphPieceKind, projectId: string, id: string) =>
    api.get<GraphLayoutDto>(path(kind, projectId, id)),
  patch: (
    kind: GraphPieceKind,
    projectId: string,
    id: string,
    body: GraphLayoutPatchBody,
  ) => api.patch<GraphLayoutDto>(path(kind, projectId, id), body),
};
